/**
 * SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
 * Copyright (C) 2025 SuiteCRM Ltd.
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License version 3 as published by the
 * Free Software Foundation with the addition of the following permission added
 * to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
 * IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
 * WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 *
 * In accordance with Section 7(b) of the GNU Affero General Public License
 * version 3, these Appropriate Legal Notices must retain the display of the
 * "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
 * feasible for technical reasons, the Appropriate Legal Notices must display
 * the words "Supercharged by SuiteCRM".
 */
import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    signal,
    ViewChild,
    WritableSignal
} from '@angular/core';
import {ImageModule} from "../image/image.module";
import {LabelModule} from "../label/label.module";
import {NgIf} from "@angular/common";

@Component({
    selector: 'scrm-file-upload-area',
    standalone: true,
    imports: [
        ImageModule,
        LabelModule,
        NgIf
    ],
    templateUrl: './file-upload-area.component.html',
})
export class FileUploadAreaComponent implements OnInit {

    @ViewChild('uploadInput') uploadInput: ElementRef<HTMLInputElement>;

    elementId: string = '';
    ngOnInit(): void {
        this.elementId = this.elementId || `file-upload-area-${Math.random().toString(36).substring(2, 15)}`;
    }

    @Input() enabled: WritableSignal<boolean> = signal(true);
    @Input() acceptedTypes: string = '*/*';
    @Input() showUploadIcon: boolean = true;
    @Input() uploadLabel: string = 'LBL_UPLOAD';
    @Input() uploadDescription: string = 'LBL_FILE_FIELD_UPLOAD_BUTTON_DESCRIPTION';
    @Input() allowMultiple: boolean = false;
    @Output('onFileAdd') onFileAdd: EventEmitter<FileList> = new EventEmitter<FileList>();

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length) {
            this.onFileAdd.next(input.files)
        }
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        if (event.dataTransfer && event.dataTransfer.files.length) {
            this.onFileAdd.emit(event.dataTransfer.files)
        }
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
    }

    resetUploadArea():void {
        if (this.uploadInput) {
            this.uploadInput.nativeElement.value = '';
            this.uploadInput.nativeElement.files = null;
        }
    }

    triggerFileInput(): void {
        if (this.uploadInput && this.enabled()) {
            this.uploadInput.nativeElement.click();
        }
    }
}
